import React from 'react'
import { useTheme } from '@hooks'
import styled from 'styled-components'
import { Avatar } from '../Avatar'

interface Props {
  size?: number
  name: string
  src?: string
  borderRadius?: string | number
  getInitials?: (name?: string, fallback?: string) => string
}

const LOGO_SIZE = 128

export const BusinessLogo: React.FC<Props> = ({
  size = LOGO_SIZE,
  name,
  src,
  borderRadius,
  getInitials
}) => {
  const theme = useTheme()
  const resolvedBorderRadius = borderRadius ?? `${theme.borderRadius.md}rem`

  return src ? (
    <StyledLogo backgroundSrc={src} size={size} borderRadius={resolvedBorderRadius} />
  ) : (
    <StyledAvatar
      size={size}
      name={name}
      borderRadius={resolvedBorderRadius}
      shape="square"
      title={name}
      getInitials={getInitials}
    />
  )
}

const StyledLogo = styled.div<{
  backgroundSrc: string
  size: number
  borderRadius: string | number
}>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  background-image: url(${({ backgroundSrc }) => backgroundSrc});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-origin: content-box;
  border-radius: ${({ borderRadius }) =>
    typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius};
`

const StyledAvatar = styled(Avatar)``
